// extracted by mini-css-extract-plugin
module.exports = {"custom_button_style":"custombutton_custom_button_style__G-MyD","custom_button_disabled_style":"custombutton_custom_button_disabled_style__2QK4s"};